import { useState } from 'react';
import { faqList } from '@/mocks/animeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqList[0]?.id ?? null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">你可能想知道</h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            关于片源、更新频率和挑选方法的问题，这里一次性说清楚。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqList.map((f) => {
            const isOpen = openId === f.id;
            return (
              <div
                key={f.id}
                className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : f.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900">{f.q}</span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-background-100 text-primary-600 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                  >
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}